export default __webpack_public_path__ + "static/media/excelIcon.217d73db.svg";